import { useMemo } from 'react';

import { arrayHasLength } from '@givebacks/utils/array';
import { ClickableOptionsCard } from 'core/Components';
import { useNavigate } from 'react-router-dom';
import { Skeleton, Text } from 'ui';
import { useGetWalletActivity } from '~/hooks/queries/Ledger/owner';

import { AccountBalance } from '../AccountBalance/AccountBalance';

const AccountBalanceRewardsCard = () => {
  const navigate = useNavigate();

  const { data: walletActivity, isLoading } = useGetWalletActivity();

  const showEnrollCTA = useMemo(() => {
    return arrayHasLength(walletActivity?.pages?.[0]?.entries);
  }, [walletActivity?.pages]);

  return (
    <ClickableOptionsCard variant="gray">
      <AccountBalance />
      {!showEnrollCTA ? (
        <ClickableOptionsCard.Row
          title={
            <Skeleton visible={isLoading}>
              <Text fz="sm" fw={500}>
                Enroll in Givebacks Rewards
              </Text>
            </Skeleton>
          }
          subtitle={
            <Skeleton visible={isLoading}>
              <Text fz="xxxs" c="gray">
                Earn Rewards automatically when you shop or dine, then use them toward school costs,
                redeem them for cash back, or donate them to your school.
              </Text>
            </Skeleton>
          }
          onClick={() => navigate('card')}
          disabled={isLoading}
        />
      ) : (
        <ClickableOptionsCard.Row
          title={
            <Skeleton visible={isLoading}>
              <Text fz="sm" fw={500}>
                Rewards Activity
              </Text>
            </Skeleton>
          }
          onClick={() => navigate('rewards')}
        />
      )}
    </ClickableOptionsCard>
  );
};

export { AccountBalanceRewardsCard };
